import { Observable } from 'rxjs'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
export abstract class StateGateway {
    abstract getAllStates(): Observable<ValidatedSelectOptionModel[]>
}
